import React from "react";
import { Hero } from "@/components/home/Hero";
import { BalmSection } from "@/components/home/BalmSection";
import { Connector } from "@/components/home/Connector";
import { PatchSection } from "@/components/home/PatchSection";
import { PatchArmSection } from "@/components/home/PatchArmSection";
import { WhyLove } from "@/components/home/WhyLove";
import { TwoStep } from "@/components/home/TwoStep";
import { ShopRange } from "@/components/home/ShopRange";
import { BundleBuilder } from "@/components/home/BundleBuilder";
import { SubscribeSave } from "@/components/home/SubscribeSave";
import { Ingredients } from "@/components/home/Ingredients";
import { Reviews } from "@/components/home/Reviews";
import { FAQ } from "@/components/home/FAQ";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <BalmSection />
      <Connector />
      <TwoStep />
      <PatchSection />
      <PatchArmSection />
      <WhyLove />
      <ShopRange />
      <BundleBuilder />
      <SubscribeSave />
      <Ingredients />
      <Reviews />
      <FAQ />
    </main>
  );
}
